<template>
  <!-- ExtractHome -->
  <div id="ExtractHome">
    <!-- 内容区域 -->

    <el-container style="width: 100%;height: 100%; background: #fff;">
      <el-header>
        <mu-appbar class="is-full-width" v-bind:title="titleStr" color="#fff" textColor="#303644" z-depth=0>
          <mu-button @click="leftBtn" icon slot="left">
            <mu-icon value="arrow_back"></mu-icon>
          </mu-button>
        </mu-appbar>
      </el-header>

      <el-main>
          <ExtractHomeHead ref="ExtractHomeHead" style="width: 100%;"></ExtractHomeHead>

          <mu-tabs :value.sync="active" indicator-color="#303644" inverse color="#303644" text-color="#303644" full-width>
              <mu-tab @click="changeTabs($event)" value="0">All</mu-tab>
              <mu-tab @click="changeTabs($event)" value="3">Deposit</mu-tab>
              <mu-tab @click="changeTabs($event)" value="1">Withdraw</mu-tab>
              <mu-tab @click="changeTabs($event)" value="2">Transaction</mu-tab>
            </mu-tabs>

<el-card style="margin: 0.625rem auto;width: 100%;height: 100%;">
  <font style="font-weight: bold;">Recent Transaction Records</font>

              <el-table :data="tableData" style="width: 100%;" :default-sort="{prop: 'date', order: 'descending'}":show-header="false" empty-text="wait"
                >
                    <!-- <el-table-column
                      prop="creationTime"
                      label="1"
                       align="left">
                    </el-table-column> -->
                    <el-table-column prop="sellVol" label="SellVol" sortable filter-placement="bottom-end" align="left">
                      <template slot-scope="scope">
                        <p style="text-align: center;float: left;">
                          {{scope.row.creationTime.slice(0,19)}}
                        </p>
                        <!-- <p style="background-color: #ff0000; border-radius: 5px;text-align: center;">
                           <font color="#ffffff"> {{scope.row.sellVol}} %</font>
                        </p> -->
                      </template>
                    </el-table-column>
                    <!-- <el-table-column
                      label="2"
                       align="right"
                        slot-scope="scope">
                    +{{scope.row.count}}
                    </el-table-column> -->
                    <el-table-column prop="sellVol" label="SellVol" sortable filter-placement="bottom-end" align="right">
                      <template slot-scope="scope">
                        <p style="text-align: center;float: right;">
                          <font v-if="scope.row.count > 0">+</font>{{scope.row.count}}
                        </p>
                        <!-- <p style="background-color: #ff0000; border-radius: 5px;text-align: center;">
                           <font color="#ffffff"> {{scope.row.sellVol}} %</font>
                        </p> -->
                      </template>
                    </el-table-column>
                  </el-table>
</el-card>

        <!-- <mu-flex class="is-full-width content" fill style="overflow-y: auto;">
          <div class="CodeForm">

            <p style="width: 100%;text-align: center;margin-top: 1.25rem;font-size: 1.5625rem;">BTC Address</p>

            <div id="qqq">
              <div id="qrCode" ref="qrCodeDiv"></div>
            </div>
            <p id="codeText" style="width: 100%;text-align: center;">xxxxxxxxxxxxxxx</p>

            <mu-button @click="submit($event)" class="copyBtn">Copy the above address</mu-button>
          </div>
        </mu-flex> -->

      </el-main>
      <!-- <el-footer>
          <BottomNav style="height: 100%; width: 100%;"></BottomNav>
          </el-footer> -->
    </el-container>


  </div>
</template>

<script>
  import {
    lStorage,
    sStorage
  } from "@Comm/js/Storage.js"
  import ExtractHomeHead from './ExtractHome_Head.vue'
  export default {
    data() {
      return {
        active: 0,
        //表格
        tableData: [],
        //下拉刷新，上拉加载
        refreshing: false,
        loadings: false,
        loadedall: false,
        titleStr: ''
      }
    },
    mounted() {
  //     var UserInfo = JSON.parse(sStorage.getItem("UserInfo"));
  //     this.UserType = UserInfo.type;

  //     window.T_Details = this;
  // console.log(this.$route.query.Name)
  // console.log(this.$route.query.Num)
  // console.log(this.$route.query.USDT)
      this.titleStr = this.$route.query.Name;
this.$refs.ExtractHomeHead.titleStr = this.titleStr;
this.$refs.ExtractHomeHead.Num = this.$route.query.Num;
this.$refs.ExtractHomeHead.USDT = this.$route.query.USDT;
      this.loadData();
    },
    methods: {
      leftBtn() {
        this.$router.go(-1); //返回上一层
      },
      changeTabs(e){
        // console.log(e);
        console.log(this.active);
      this.loadData();
      },
      formatDate(createTime){

      return new Date(createTime).Format("yyyy-MM-dd HH:mm:ss");

      },
      loadData() {
        const that = this;

        let params = new URLSearchParams();
        params.append('type', this.active);
  	params.append('token',sStorage.getItem("token"));
        this.$http.get('/record/Record', {
            params
          })
          .then(function(response) {
            console.log(response.data);
            that.refreshing = false;
            if (response.data.success || response.data.code == 1) {
              that.tableData = response.data.content;
            } else {
              that.$message.error(response.data.message);
            }
          });
      }
    },
    components: {
      ExtractHomeHead
    }
  };
</script>

<style>
  @import '../../../Comm/css/CommCSS.css';
  /* #ExtractHome .mu-appbar .mu-appbar-title {
     text-align: center;
   } */
   #ExtractHome .is-full-width {
     width: 100%;
     height: 100%;
   }

   #ExtractHome .content {
     flex: 1
   }

   #ExtractHome .el-header {
    padding: 0 0px;
   }

   #ExtractHome .el-main {
       padding: 0px;
   }
   #ExtractHome .el-table .el-table__cell {
       padding: 0px 0;
   }
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Extract/ExtractHome.vue